"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var patch_exports = {};
__export(patch_exports, {
  PatchType: () => PatchType
});
module.exports = __toCommonJS(patch_exports);
var PatchType = /* @__PURE__ */ ((PatchType2) => {
  PatchType2["update"] = "update";
  PatchType2["remove"] = "remove";
  PatchType2["reaction"] = "reaction";
  PatchType2["attachment"] = "attachment";
  PatchType2["thread"] = "thread";
  return PatchType2;
})(PatchType || {});
//# sourceMappingURL=patch.js.map
